var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfusiones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 719.54 1015.16",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M719.45,271.03c0-84.27-68.56-152.84-152.83-152.84h-10.44l.03.04h-106.28c2.32-8.26,3.49-16.49,3.49-24.55,0-51.66-42.02-93.68-93.67-93.68s-93.68,42.02-93.68,93.68c0,8.06,1.17,16.29,3.49,24.55h-116.72C68.57,118.23,0,186.8,0,271.07v473.02c0,84.27,68.57,152.83,152.84,152.83h54.12v83.68c0,19.06,15.5,34.56,34.56,34.56s34.55-15.5,34.55-34.56v-83.68h167.4v83.68c0,19.06,15.5,34.56,34.55,34.56s34.56-15.5,34.56-34.56v-83.68h54.12c84.27,0,152.84-68.56,152.84-152.83l-.09-473.06ZM359.7,69.08c13.54,0,24.55,11.01,24.55,24.56s-11.01,24.55-24.55,24.55-24.56-11.01-24.56-24.55,11.01-24.56,24.56-24.56ZM152.75,187.35h413.9c44.46,0,80.93,34.86,83.53,78.68H69.22c2.59-43.82,39.07-78.68,83.53-78.68ZM650.33,744.04c0,46.14-37.54,83.68-83.68,83.68H152.75c-46.14,0-83.68-37.54-83.68-83.68v-408.9h581.26v408.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.74,592.66l-65.94-143.99h.5l-3.14-7.03c-5.43-12.21-17.78-20.1-31.46-20.1s-25.84,7.87-31.44,20.05l-69.18,151.07c-15.86,34.47-13.07,73.95,7.44,105.6,20.37,31.79,55.1,50.78,92.89,50.78s72.51-18.99,92.88-50.78c20.4-31.83,23.18-71.31,7.45-105.6ZM359.71,679.03h-.03c-14.52-.01-27.51-6.77-34.75-18.06-7.69-12.21-8.75-26.66-2.92-39.61l37.73-82.33,37.74,82.34c5.8,12.6,5.17,25.9-1.75,37.7l-1.2,1.86c-7.28,11.34-20.29,18.1-34.82,18.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfusiones);
export default __webpack_public_path__ + "static/media/Transfusiones.efac05d73673110b1f595dd3525badda.svg";
export { ForwardRef as ReactComponent };